import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { ProcessosJudiciaisDTO } from "types/dto/ProcessosJudiciaisDTO";

export const useGetEditarVisualizarProcessoJudicial = (processoId: number | null) => {
  const onError = () => {
    toast.error("Erro ao buscar processo judicial");
  };

  return useFetch<ProcessosJudiciaisDTO>({
    key: ["processo-judicial-edicao-visualizacao", processoId],
    url: `${api.processosJudiciais.getEditarVisualizarProcessosJudiciais}/${processoId}`,
    onError,
    enabled: processoId != null,
  });
};
